










































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import UiIcon from '../UiIcon'
import UiProductCards from '../UiProductCards'
import UiProductLabel from '../UiProductLabel'
import { PropsData } from './UiRobotFinder.interface'

@Component({
  components: {
    UiIcon,
    UiProductCards,
    UiProductLabel
  }
}
)
export default class UiRobotFinder extends Vue {
  @Prop({ type: Object, required: true }) readonly propsData!: PropsData

  currentFilterIndex = 0
  selectedOptionValues: (string | number | undefined)[] = []
  previouslySelectedOptionValues: (string | number | undefined)[] = []

  get filteredProducts () {
    return this.propsData.products.filter(product => {
      let leaveCurrentProduct = true
      for (let i = 0; i < this.selectedOptionValues.length; i++) {
        const currentOptionValue = this.selectedOptionValues[i]
        if (typeof currentOptionValue === 'undefined') {
          continue
        }

        const currentFilterOptionIndex = this.propsData.filters[
          i
        ].options.findIndex(o => o.value === currentOptionValue.toString())

        const currentComparisonMethod = this.propsData.filters[i].options[
          currentFilterOptionIndex
        ].comparison

        const currentAttributeName = this.propsData.filters[i].attribute
        if (product?.productData?.filterAttributes) {
          for (let j = 0; j < product?.productData?.filterAttributes?.length; j++) {
            const attrName = product.productData.filterAttributes[j][0]
            const attrValue = product.productData.filterAttributes[j][1]

            if (attrName === currentAttributeName) {
              // eq
              if (
                currentComparisonMethod === 'eq' &&
                !(attrValue === currentOptionValue)
              ) {
                leaveCurrentProduct = false
                break
              }
              // in
              if (
                currentComparisonMethod === 'in' &&
                Array.isArray(attrValue)
              ) {
                if (!attrValue.includes(currentOptionValue.toString())) {
                  leaveCurrentProduct = false
                  break
                }
              }

              // lt
              if (
                currentComparisonMethod === 'lt' &&
                !(attrValue < currentOptionValue)
              ) {
                leaveCurrentProduct = false
                break
              }

              // lte
              if (
                currentComparisonMethod === 'lte' &&
                !(attrValue <= currentOptionValue)
              ) {
                leaveCurrentProduct = false
                break
              }

              // gt
              if (
                currentComparisonMethod === 'gt' &&
                !(attrValue > currentOptionValue)
              ) {
                leaveCurrentProduct = false
                break
              }

              // gte
              if (
                currentComparisonMethod === 'gte' &&
                !(attrValue >= currentOptionValue)
              ) {
                leaveCurrentProduct = false
                break
              }
            }
          }
        }

        if (leaveCurrentProduct === false) break
      }

      return leaveCurrentProduct
    })
  }

  setCurrentFilterIndexManually (index: number) {
    this.currentFilterIndex = index
  }

  setOptionValue (filterIndex: number, optionValue: string | number, castToInt: boolean) {
    this.previouslySelectedOptionValues = [...this.selectedOptionValues]
    if (castToInt) {
      optionValue = Number(optionValue)
    }
    if (this.selectedOptionValues[filterIndex] === optionValue) {
      this.selectedOptionValues[filterIndex] = undefined
    } else {
      this.selectedOptionValues[filterIndex] = optionValue
    }
    this.selectedOptionValues = [...this.selectedOptionValues]
  }

  @Watch('selectedOptionValues')
  switchToNotSelectedYetFilterTab () {
    /**
     * When some option was deleted by click on button located
     * on the yellow background, switch to appropriate filter tab.
     */
    for (let i = 0; i < this.selectedOptionValues.length; i++) {
      if (
        this.selectedOptionValues[i] !==
          this.previouslySelectedOptionValues[i] &&
        typeof this.selectedOptionValues[i] === 'undefined'
      ) {
        return (this.currentFilterIndex = i)
      }
    }

    let nextNotDefinedFilterIndex: undefined | number

    if (this.filteredProducts.length === 0) return

    if (this.currentFilterIndex + 1 !== this.propsData.filters.length) {
      const candidateIndex = this.selectedOptionValues
        .slice(this.currentFilterIndex)
        .findIndex(Object.is.bind(null, undefined))
      if (candidateIndex !== -1) {
        nextNotDefinedFilterIndex = candidateIndex + this.currentFilterIndex
      }
    }

    if (!nextNotDefinedFilterIndex) {
      const candidateIndex = this.selectedOptionValues.findIndex(
        Object.is.bind(null, undefined)
      )
      if (candidateIndex !== -1) {
        nextNotDefinedFilterIndex = candidateIndex
      }
    }

    if (typeof nextNotDefinedFilterIndex === 'undefined') return
    this.currentFilterIndex = nextNotDefinedFilterIndex
  }

  created () {
    const numberOfFilters = this.propsData.filters.length
    this.selectedOptionValues = new Array(numberOfFilters)
  }
}
